export var State;
(function (State) {
    State[State["Earth"] = 0] = "Earth";
    State[State["Traversing"] = 1] = "Traversing";
    State[State["Waiting"] = 2] = "Waiting";
    State[State["WaitingInteractively"] = 3] = "WaitingInteractively";
})(State || (State = {}));
//# sourceMappingURL=State.js.map